import Vue from 'vue';
import { mapState } from 'vuex';

Vue.mixin({
  computed: {
    ...mapState({
      token: state => state.Menu.token,
      userId: state => state.Menu.userInfo?.id,
      orderId: state => state.Menu.orderId,
      userInfo: state => state.Menu.userInfo || {},
      accessStatus: state => state.Menu.accessStatus,
      storeServes: state => state.Menu.storeServes,
      toLoginPath: state => state.Menu.toLoginPath,
      loginParams: state => state.Menu.loginParams,
      language: state => state.Menu.language,
      logged: state => {
        const { token, userInfo } = state.Menu;
        const localToken = localStorage.getItem('token');
        return (token || localToken) && userInfo && userInfo?.id;
      },

      storeUrl: state => state.prefetch.storeUrl,
      storeInfo: state => state.prefetch.storeInfo,
      // 是否为无注册购买
      guestCheckout: state => state.prefetch.storeInfo.guestCheckout,
      categoryData: state => state.prefetch.categoryData,
      cartDetailData: state => state.prefetch.cartDetailData,
      // 酒店、房间服务 Dine in
      isRoomService: state => state.prefetch.storeInfo.businessType === 100,
      // 公寓类型 Dine in
      isApartment: state => state.prefetch.storeInfo.businessType === 700,
      // 普通Dine in
      isNormalDineIn: state => {
        const type = state.prefetch.storeInfo.businessType;
        return ![100, 700].includes(type);
      },
      isSupprotService: state => {
        const serviceType = state.Menu.accessStatus;
        const serviceTypes = state.prefetch.storeInfo?.service || [];
        const opendOrderType = Object.keys(serviceTypes).filter(it => serviceTypes[it]);
        return opendOrderType.includes(serviceType);
      },
      fullDineInTableData: state => state.Menu.fullDineInTableData,
      // current type var
      isFullDineIn: state => state.Menu.accessStatus === 'FULL_DINE_IN',
      isDine: state => state.Menu.accessStatus === 'DINE_IN',
      isDelivery: state => state.Menu.accessStatus === 'DELIVERY',
      isPickup: state => state.Menu.accessStatus === 'PICK_UP',
      fullDineInOrderId: state => {
        const { order, cart } = state.Menu.fullDineInTableData;
        const { orderId } = state.Menu
        return order?.orderDetail?.orderId || cart.orderId || orderId;
      },
      emailOptional: state => state.prefetch.storeInfo.emailOptional,
      // 是否关店
      storeOpened: state => [200, 400].includes(state.prefetch.storeInfo?.status?.statusCode),
      // 是否开启了预定单
      scheduledOpened: state => {
        const store = state.prefetch.storeInfo;
        if (!store) return false;
        const {
          scheduledEnable,
          scheduledDelivery,
          scheduledDineIn,
          scheduledPickUp,
        } = store?.scheduled || {};
        return (scheduledEnable && (scheduledDelivery || scheduledDineIn || scheduledPickUp));
      },
      // 是否能进行下单流程，加购,购物车order，购物车按钮等
      serviceOpened: (state) => {
        const { service } = state.prefetch.storeInfo || {};
        if (!service) return false;
        const { DELIVERY, DINE_IN, FULL_DINE_IN, PICK_UP } = service;
        return DELIVERY || DINE_IN || FULL_DINE_IN || PICK_UP;
      }
    }),
  },
  methods: {
    _rpush(location, ...args) {
      if (typeof location === 'string') {
        this.$router.push(`/${this.storeUrl}/${location}`, ...args);
      } else {
        this.$router.push(location, ...args);
      }
    }
  }
});
